import { createFileRoute } from '@tanstack/react-router'
import GiftCardRefund from '../../../../../../components/RefundUIs/GiftCardRefund'

export const Route = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/gift-cards',
)({
  component: GiftCardPayment,
})

function GiftCardPayment() {
  return <GiftCardRefund type='giftcards'/>
}
